import { render, staticRenderFns } from "./bulk-message-template-create-page.vue?vue&type=template&id=5bb78ed8&scoped=true&"
import script from "./bulk-message-template-create-page.vue?vue&type=script&lang=js&"
export * from "./bulk-message-template-create-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb78ed8",
  null
  
)

export default component.exports